import React, { useState, useEffect } from "react";
import { Form, Modal, Message } from "semantic-ui-react";
import { useForm } from "react-hook-form";
import { useAuth } from "../../../AuthenticationStore";
import { proccessError } from "../../../components/utils/utils";

export const RolOptions = [
  { key: "0", text: "Super-Admin", value: "0" },
  { key: "1", text: "CTO", value: "1" },
  { key: "2", text: "CEO", value: "2" },
  { key: "3", text: "CMO", value: "3" }
];

export const RolOptionsInvitations = [
  { key: "1", text: "CTO", value: "1" },
  { key: "2", text: "CEO", value: "2" },
  { key: "3", text: "CMO", value: "3" }
];

export const UserModal = ({ handleClose, show, data }) => {
  const [errorsApi, setErrorsApi] = useState([]);
  const { handleSubmit, register, errors, setValue } = useForm();
  const { platformUserService } = useAuth();

  useEffect(() => {
    if (!data) return;

    for (const key in data) {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(key)) {
        const value = data[key];
        setValue(key, value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const onSubmit = async values => {
    try {
      values.id = data.platformUserId;
      // use create company
      const response = await platformUserService.modifyPlatformUser(values);

      const arrayErrors = proccessError(response);
      setErrorsApi(arrayErrors);
      if (response.result) handleClose(false);
    } catch (error) {
      if (error.response) {
        // eslint-disable-next-line no-console
        const arrayErrors = proccessError(error.response.data, true);
        setErrorsApi(arrayErrors);
      } else {
        setErrorsApi([error.message]);
      }
    }
  };

  return (
    <Modal open={show} onClose={handleClose} closeIcon>
      <Modal.Header>Editar usuario</Modal.Header>
      <Modal.Content>
        {errorsApi.length > 0 ? (
          <Message error>
            <Message.Header>Errores</Message.Header>
            <Message.List items={errorsApi} />
          </Message>
        ) : null}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Input
            fluid
            error={!!errors.userName}
            label="Nombre"
            placeholder="Nombre"
          >
            <input
              name="userName"
              ref={register({
                required: "Required"
              })}
            />
          </Form.Input>

          <Form.Input
            fluid
            error={!!errors.mobile}
            label="Teléfono"
            placeholder="Teléfono"
          >
            <input
              name="mobile"
              ref={register({
                required: "Required"
              })}
            />
          </Form.Input>

          <button className="btn btn-primary btn-icon-text" type="submit">
            <i className="mdi mdi-content-save"></i>
            {data ? "Editar" : "Agregar"}
          </button>
        </Form>
      </Modal.Content>
    </Modal>
  );
};
